export enum TransactionType {
    ChangeOneTouch = 'change_one_touch',
    ChangePassword = 'change_password',
    ChangePhone = 'change_phone',
    Onboarding = 'onboarding',
    PasswordReset = 'password_reset',
    RemoveOneTouch = 'remove_one_touch',
    RemovePhone = 'remove_phone',
    VaultKeyRemoval = 'vault_key_removal'
}

export enum TransactionMethodType {
    Approval = 'approval',
    Enroll = 'enroll'
}

export enum TransactionState {
    Approved = 'approved',
    Closed = 'closed',
    Expired = 'expired',
    Open = 'open',
    Pending = 'pending',
    Proven = 'proven',
    Rejected = 'rejected'
}

export enum TransactionsErrorCode {
    AccountInactive = 'account-inactive',
    ApprovalMethodRequired = 'transaction:approval-method-required',
    AuthenticationError = 'transaction:authentication-error',
    ErrorProcessingRequest = 'error-processing-request',
    ExpiredInvitation = 'transaction:expired-invitation',
    ExpiredResetToken = 'transaction:expired-reset-token',
    ExpiredTransaction = 'transaction:expired-transaction',
    ImmutableTransaction = 'transaction:immutable-transaction-state',
    InvalidApprovalMethod = 'transaction:invalid-approval-method',
    InvalidTransaction = 'transaction:invalid-transaction',
    InvitationInvalid = 'transaction:invitation-invalid',
    MemberCreateException = 'onboarding:member-create-exception',
    RemovalRequestExpired = 'transaction:removal-request-expired',
    RemovalRequestInProgress = 'transaction:removal-request-in-progress',
    RemovalRequestInvalid = 'transaction:removal-request-invalid',
    RemovalRequestUnconfirmed = 'transaction:removal-request-unconfirmed',
    Throttled = 'throttled',
    TransactionExpired = 'transaction:transaction-expired',
    TransactionNotFound = 'transaction:transaction-not-found',
    WrongEmailCode = 'transaction:email:wrong-code'
}

export enum Reset2FAStep {
    Complete = 'Complete',
    DownloadFuturae = 'DownloadFuturae',
    Setup2FA = 'Setup2FA',
    SetupFuturae = 'SetupFuturae',
    SetupPhoneNumber = 'SetupPhoneNumber',
    VerifyPassword = 'VerifyPassword',
    VerifyPhoneNumber = 'VerifyPhoneNumber'
}
